import { Outlet } from 'react-router-dom'

const Ports = () => {
  return <Outlet />
}

export default Ports
